<template>
    <section>
        <v-header v-if="contentVisible" id="globalHeader"></v-header>
        <div id="globalPage" class="page">
            <router-view/>
            <back-to-top>
            </back-to-top>
        </div>
        <v-footer v-if="contentVisible" id="globalFooter"></v-footer>
    </section>
</template>

<script>
    import header from '@/components/Header'
    import footer from '@/components/Footer'
    import BackToTop from '@/components/common/BackToTop'

    export default {
        name: 'app-main',
        components: {
            'v-header': header,
            'v-footer': footer,
            BackToTop,
        },
        data() {
            return {
                contentVisible: false,
            }
        },
        watch: {
            '$route':
                {
                    immediate: true,
                    deep: true,
                    handler() {
                        let path = this.$route.path;
                        this.contentVisible = path !== '/login';
                    }
                }
            ,
        }
    }
</script>